import os from 'os';

/* eslint-disable */
export const config = require("./../../config/config." + os.hostname() + ".json");

export default config;
